__turbopack_context__.v({
  "input": "price-filter-module-scss-module__1hd5ha__input",
  "inputWrapper": "price-filter-module-scss-module__1hd5ha__inputWrapper",
  "inputs": "price-filter-module-scss-module__1hd5ha__inputs",
  "label": "price-filter-module-scss-module__1hd5ha__label",
  "root": "price-filter-module-scss-module__1hd5ha__root",
  "separator": "price-filter-module-scss-module__1hd5ha__separator",
  "title": "price-filter-module-scss-module__1hd5ha__title",
});
